// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginNative_wrapper__QHzS+","content":"LoginNative_content__50S1Z"};